<template lang="pug">
	.end-card-selector(v-if="showed")
		.card
			.card-header
				span Select End Card
			.card-body.collapse.show
				.end-cards(:span="8")
					.end-card-container(v-for="endCard in endCards" :class="{selected: endCard.id === selectedEndCardVersionId}" @click="select(endCard)")
						.preview(:style="{backgroundImage: Version.getVersionScreenshot(Project.Projects[endCard['project_id']], endCard)}")
						span.title {{endCard.title}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" :class="{disabled: !selectedEndCardVersionId}" v-on:click="create()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Select
						button.btn.btn-dark(type="button" v-on:click="close()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Metadata } 		from './../../services/Metadata'

	export default {
		name: "EndCardSelector",
		mixins: [Screen],
		screen: {
			events: {
				"Show EndCardSelector": function() {

					this.selectedEndCardVersionId = '';

				}
			}
		},
		data() {

			this.endCards = [];

			return {
				showed: false,
				selectedEndCardVersionId: ''
			};

		},
		methods: {
			collectData() {

				this.endCards = this.getEndCardProjectsVersions();

			},
        	getEndCardProjectsVersions() {

        		let result = [];

        		_.each(Version.Versions, version => {

        			let project = Project.Projects[version['project_id']];
        			if (!project) return;

        			//Пропускаем не конечные карточки
        			if (project.type !== 'end-card') return;
        			//Пропускаем конечные карточки других паблишеров
        			if (project['publisher_id'] !== Publisher.SelectedPublisher?.id) return;

        			//Пропускаем если данная конечная карточка предназначена для определённого типа проектов и текущий проект не входит в этот тип (маркеры)
        			if (project.options.endCardMarkers && project.options.endCardMarkers.length > 0 && _.intersection(project.options.endCardMarkers, Project.SelectedProject.options.markers || []) === 0) return;

					result.push(version);

				});

        		return result;

			},
			close() {

				this.hide();

			},
			select(endCard) {

				this.selectedEndCardVersionId = endCard.id;

			},
			create() {

				if (!this.selectedEndCardVersionId) return;

				Settings.sendDatabaseSetting('end-card-version-id', this.selectedEndCardVersionId);

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.end-card-selector
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 750px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.end-cards
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				max-height: 360px
				overflow-y: auto

				.end-card-container
					display: flex
					flex-direction: column
					align-items: center
					width: 200px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 200px
						height: 200px
						margin: 10px
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title
						margin-bottom: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.form-control
					width: 250px

</style>

